import React from "react";
import { isMobile, isTablet } from "react-device-detect";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import "./myLinksSkeleton.css";

interface SkeletonProps {
  templateType: "grid" | "line";
  count?: number;
  designTokens?: any;
  matchContentLayout?: boolean;
  isMobileView?: boolean;
  isDashboard?: boolean;
}

function getSingleRowGridCount(isMobileView?: boolean) {
  if (isMobileView) return 2;
  if (typeof window !== "undefined" && window.innerWidth <= 392) return 2;
  if (typeof window !== "undefined" && window.innerWidth <= 600) return 3;
  return 4;
}

export const MyLinksSkeleton: React.FC<SkeletonProps> = ({
  templateType,
  count = 3,
  designTokens,
  matchContentLayout = false,
  isMobileView = false,
  isDashboard = false,
}) => {

  const GridSkeleton = () => (
    <>
      <div className="mainDiv"></div>
      <div
        className="grid-skeleton-card"
        style={{
          border: designTokens?.tertiaryColor
            ? `1px solid ${designTokens?.tertiaryColor}`
            : "",
        }}
      >
        <div className="grid-skeleton-image">
          <Skeleton
            height={160}
            width="95%"
            baseColor={designTokens?.primaryColor}
            highlightColor={designTokens?.primaryColor}
            style={{
              margin: "5px",
              border: designTokens?.secondaryColor ? `none` : "",
            }}
          />
        </div>
        {/* <div className="grid-skeleton-content">
          <Skeleton
            height={55}
            width="95%"
            baseColor={designTokens?.primaryColor}
            highlightColor={designTokens?.primaryColor}
            style={{
              border: designTokens?.secondaryColor ? `1px solid white` : "",
            }}
          />
        </div> */}
      </div>
    </>
  );

  const LineSkeleton = () => (
    <div className="line-skeleton-card"
    style={{
      border: designTokens?.tertiaryColor ? `1px solid ${designTokens?.tertiaryColor}` : "",
      backgroundColor: designTokens?.primaryColor ? designTokens?.primaryColor : "",

    }}
    >
      {/* <div className="line-skeleton-image">
        <Skeleton
          circle
          height={50}
          width={50}
          baseColor={designTokens?.primaryColor}
          highlightColor={designTokens?.primaryColor}
          style={{
            border: designTokens?.secondaryColor ? `1px solid ${designTokens?.secondaryColor}` : "",
          }}
        />
      </div> */}
      <div className="line-skeleton-content">
        <Skeleton
          height={50}
          width="100%"
          baseColor={designTokens?.primaryColor}
          highlightColor={designTokens?.primaryColor}
          style={{
            border: designTokens?.tertiaryColor ? `none` : "",
          }}
        />
      </div>
    </div>
  );

  // ── Opt-in only: match GridTemplate content layout (scoped CSS classes) ───
  if (matchContentLayout && templateType === "grid") {
    const isDefaultTheme =
      !designTokens?.tertiaryColor ||
      designTokens?.tertiaryColor === "#e6e7eb";
    const gridCount = getSingleRowGridCount(isMobileView);

    const gridClassName = [
      "my-links-skeleton",
      "grid-layout",
      isDashboard ? "grid-layout--dashboard" : "grid-layout--frontend",
      !isDashboard && isMobileView ? "mobile-view" : "",
    ]
      .filter(Boolean)
      .join(" ");

    return (
      <div className={gridClassName} style={{marginTop:"15px"}}>
        {[...Array(gridCount)].map((_, index) => (
          <div
            key={index}
            className="my-links-grid-skeleton-card"
            style={{
              border: designTokens?.tertiaryColor
                ? `1px solid ${designTokens?.tertiaryColor}`
                : undefined,
            }}
          >
            <div className="my-links-grid-skeleton-image">
              <Skeleton
                width="100%"
                height="100%"
                baseColor={
                  isDefaultTheme
                    ? "#f1f1f1"
                    : designTokens?.primaryColor || "#f1f1f1"
                }
                highlightColor={
                  isDefaultTheme
                    ? "#f1f1f1"
                    : designTokens?.primaryColor || "#f1f1f1"
                }
              />
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className={`skeleton-container ${templateType}-layout`}>
      {[...Array(count)].map((_, index) => (
        <div key={index} className={templateType === "grid" ? "" : "w-100"}>
          {templateType === "grid" ? <GridSkeleton /> : <LineSkeleton />}
        </div>
      ))}
    </div>
  );
};
